export const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) }
